export default {
    langFn(state, canshu) {
        state.lang = canshu;
    },
    currency_rootFn(state, canshu) {
        state.currency_root = canshu;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js